"use client";

import React from "react";
import Link from "next/link";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { User, Settings, LogOut, ShieldAlert } from "lucide-react";

export function ProfileMenu() {
  // Mock data for user until Phase 004 Auth is completed
  const user = {
    name: "Alessio Corrado",
    email: "alessio@quario.ai",
    role: "Owner / Director",
    avatarUrl: null, // trigger default initials
  };

  const initials = user.name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .substring(0, 2)
    .toUpperCase();

  const handleLogout = () => {
    console.log("Logout triggered");
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className="flex items-center gap-2 outline-none cursor-pointer p-1 rounded-full hover:bg-card-muted transition-colors select-none">
          <div className="h-8 w-8 rounded-full bg-primary-600 text-text-on-primary flex items-center justify-center text-xs font-semibold shadow-sm">
            {initials}
          </div>
          <div className="hidden md:flex flex-col items-start text-xs pr-2">
            <span className="font-semibold text-text-primary leading-tight">
              {user.name}
            </span>
            <span className="text-text-muted text-[10px] leading-tight">
              {user.role}
            </span>
          </div>
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={8}
          className="z-50 min-w-[220px] overflow-hidden rounded-xl border border-border bg-card p-1 shadow-hover text-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 duration-100"
        >
          {/* User info header */}
          <div className="px-3 py-2 text-xs border-b border-border/50 mb-1">
            <p className="font-semibold text-text-primary">{user.name}</p>
            <p className="text-text-muted truncate">{user.email}</p>
          </div>

          <DropdownMenu.Item asChild>
            <Link
              href="/settings/profile"
              className="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg hover:bg-card-muted hover:text-foreground cursor-pointer outline-none transition-colors"
            >
              <User className="h-4 w-4 text-text-secondary" />
              <span>Profilo Personale</span>
            </Link>
          </DropdownMenu.Item>

          <DropdownMenu.Item asChild>
            <Link
              href="/settings"
              className="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg hover:bg-card-muted hover:text-foreground cursor-pointer outline-none transition-colors"
            >
              <Settings className="h-4 w-4 text-text-secondary" />
              <span>Impostazioni</span>
            </Link>
          </DropdownMenu.Item>

          <DropdownMenu.Item asChild>
            <Link
              href="/admin"
              className="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg hover:bg-card-muted hover:text-foreground cursor-pointer outline-none transition-colors"
            >
              <ShieldAlert className="h-4 w-4 text-text-secondary" />
              <span>Console Admin</span>
            </Link>
          </DropdownMenu.Item>

          <DropdownMenu.Separator className="h-px bg-border/50 my-1" />

          <DropdownMenu.Item
            onClick={handleLogout}
            className="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg hover:bg-error-soft text-error hover:text-error cursor-pointer outline-none transition-colors"
          >
            <LogOut className="h-4 w-4" />
            <span>Esci da Cleos</span>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
